export const EMPLOYEE_FILTER_NAME = "Employees";
export const TIME_GROUPS_FILTER_NAME = "TimeGroups";
export const TIME_PERIODS = "TimePeriods";
export const TIME_CARD_ALERTS = "TimeCardAlerts";
export const TableColumns = [
  { label: "Employee", field: "employee" },
  { label: "Type", field: "type" }
];
